
export function getToken() {
    if (sessionStorage.getItem("token") != undefined) {
        return sessionStorage.getItem("token")
    }
}

export function setToken(token) {
    return sessionStorage.setItem("token", token)
}

export function getUserData() {
    if (sessionStorage.getItem("userData") != undefined) {
        return sessionStorage.getItem("userData")
    }
}

export function setUserData(key, value) {
    sessionStorage.setItem(key, value);
}

export function getAboutUs() {
    if (sessionStorage.getItem("aboutUs") != undefined) {
        return sessionStorage.getItem("aboutUs")
    }
}

export function setAboutUs(data) {
    return sessionStorage.setItem("aboutUs", data)
}




// WEBPACK FOOTER //
// ./src/utils/anth.js